import { Reducer } from 'redux';
import { AdditionalScreenState,AdditionalScreenTypes } from './types';

const INITIAL_STATE: AdditionalScreenState = {
  screens: [],
  loading: false,
  error: false,
};

const reducer: Reducer<AdditionalScreenState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AdditionalScreenTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case AdditionalScreenTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload,
      };
    case AdditionalScreenTypes.LOAD_FAILURE:
      return {
        ...state,
        screens: [],
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
